export default __webpack_public_path__ + "static/media/connect-icon.cb2b8b71.png";